import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { registrationFormDefault } from "@factory/form/form.default";
import {
  RegistrationFormRule,
  RegistrationFormSchema,
} from "@factory/form/form.rule";
import { GetTenantModel } from "@factory/model/query-model-tenant";
import { useQyCreateReferral } from "@factory/query/referral.query";
import { useQyCreateRegistration } from "@factory/query/registration.query";
import { useQyGetTenantBySlug } from "@factory/query/tenant.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { calculateAge } from "@shared/utility/calculage-age";
import { useState } from "react";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import { ageConsent } from "../../../app.feature";

export function useNewRegistration() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateRegistration } = useFormApiMapper();
  const { showError, showWarning } = useNotificationContext();
  const [successDialog, setSuccessDialog] = useState(false);

  const { tenantSlug } = useParams();
  const { data: tenantResponse } = useQyGetTenantBySlug(tenantSlug || "");
  const tenantData = tenantResponse?.data as GetTenantModel;

  // QUERIES
  const handleReferralApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;
  }
  const { mutate: addReferral } = useQyCreateReferral(handleReferralApiSuccess)

  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;
    setSuccessDialog(true);
  };
  const { mutate: addRegistration, isLoading: isCreating } =
    useQyCreateRegistration(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<RegistrationFormSchema>({
    defaultValues: registrationFormDefault,
    resolver: zodResolver(RegistrationFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: RegistrationFormSchema) => {
    if (form.birthday) {
      const age = calculateAge(form.birthday);

      if (age < ageConsent) {
        showWarning(
          `Below age of consent is not allowed to participate in the program`
        );
        return;
      }
    }

    const tenant = tenantData?.code || "";
    const updatedForm = {
      ...form,
      tenant,
    } as RegistrationFormSchema;
    const formData = mapCreateRegistration(updatedForm);
    addRegistration(formData);
  };
  const handleValidateError = (err: FieldErrors<RegistrationFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    tenantData,
    successDialog,
    setSuccessDialog,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
